import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'gcv-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileCardComponent implements OnInit {
  editable = false;
  @Input() formKey: any;
  @Input() data: FormGroup;
  @Input() errors: any = [];
  @Input() validators: any = [];
  @Output() saveContent = new EventEmitter();
  tempData = {};

  constructor() {}

  ngOnInit() {}

  edit() {
    this.editable = true;
  }

  cancel() {
    this.editable = false;
  }

  save() {
    for (const key in this.tempData) {
      if (key) {
        this.data.controls[key].setValue(this.tempData[key]);
      }
    }
    this.editable = false;
    this.saveContent.emit(this.data.getRawValue());
  }

  handleInput(e) {
    this.tempData[e.property] = e.value;
  }
}
